module.exports = require('../../lib/app/shared/universal-config');



/** WEBPACK FOOTER **
 ** ./~/roc-package-web-app-react/app/shared/universal-config.js
 **/